export default "__VITE_ASSET__c9818b9c__"